"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _models = require("@seedlang/models");
var _mobx = require("mobx");
var _layouts = require("@seedlang/layouts");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var OverlayUI = (_class = /*#__PURE__*/function (_RootState) {
  function OverlayUI() {
    var _this;
    _classCallCheck(this, OverlayUI);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OverlayUI, [].concat(args));
    _initializerDefineProperty(_this, "overlays", _descriptor, _this);
    return _this;
  }
  _inherits(OverlayUI, _RootState);
  return _createClass(OverlayUI, [{
    key: "hasOverlays",
    get: function get() {
      return this.overlays.length > 0;
    }
  }, {
    key: "addOverlay",
    value: function addOverlay(name) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.hasOverlay(name)) {
        return;
      }
      var layout = new _layouts.OverlayLayout(props);
      props = Object.assign({
        layout: layout,
        overlayId: (0, _utils.createUuid)(),
        params: {}
      }, props);
      var overlayState = new _models.OverlayState(this, props);
      this.overlays.push({
        name: name,
        props: props,
        overlayState: overlayState
      });
      overlayState.set('isOpen', true);
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay(name) {
      (0, _lodash.each)(this.overlays.filter(function (item) {
        return item.name === name;
      }), function (overlay) {
        overlay.overlayState.removeOverlay();
      });
    }
  }, {
    key: "clearOverlays",
    value: function clearOverlays() {
      this.overlays = [];
    }
  }, {
    key: "setOverlays",
    value: function setOverlays(overlays) {
      this.overlays = overlays;
    }
  }, {
    key: "hasOverlay",
    value: function hasOverlay(overlayName) {
      return (0, _utils.isPresent)(this.getOverlay(overlayName));
    }
  }, {
    key: "getOverlay",
    value: function getOverlay(overlayName) {
      return this.overlays.find(function (item) {
        return item.name === overlayName;
      });
    }
  }, {
    key: "removeOverlays",
    value: function removeOverlays(ary) {
      var _this2 = this;
      (0, _lodash.each)(ary, function (name) {
        _this2.removeOverlay(name);
      });
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "overlays", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasOverlays", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOverlays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addOverlay", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addOverlay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeOverlay", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeOverlay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearOverlays", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearOverlays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOverlays", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setOverlays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasOverlay", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "hasOverlay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getOverlay", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getOverlay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeOverlays", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeOverlays"), _class.prototype), _class);
var _default = exports["default"] = new OverlayUI();